<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <el-form
      :model="category"
      ref="category"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane label="English">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              File Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="fileNameEn"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="category.fileNameEn" :name="'fileNameEn'" maxlength="60" show-word-limit/>
              </el-form-item>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Description
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="descriptionEn"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.descriptionEn"
                  :name="'descriptionEn'"
                  maxlength="600"
                  show-word-limit
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-group" v-if="category.fileType == 1">
            <label class="col-sm-2 control-label">
              Document <span style="color: red">*</span></label
            >
            <div class="col-sm-10">
              <el-upload
                class="upload-demo upload-image"
                action="#"
                multiple
                :http-request="uploadDocument"
                :auto-upload="true"
                accept=".doc, .DOC, .DOCX, .pdf, .PDF, .xls, XLS, xlsx, XLSX, .ppt, .PPT, .pptx, .PPTX, .ZIP"
                :limit="1"
                :file-list="documentFileList"
              >
                <div
                  slot="tip"
                  v-if="uploadErr"
                  style="color: red; font-size: 10px"
                  class="el-upload__tip"
                >
                  The uploaded file should not exceed 5MB
                </div>
                <el-button size="small" type="primary">Upload</el-button>
              </el-upload>
              <el-form-item
                :prop="'fileUrl'"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }"
              >
                <el-input
                  style="display: none"
                  v-model="category.fileUrl"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group" v-if="category.fileType == 1">
            <label class="col-sm-2 control-label"> Thumbnail Image </label>
            <div class="col-sm-10">
              <el-upload
                class="upload-demo upload-image"
                action="#"
                multiple
                :http-request="
                  (function (param) {
                    uploadImage(param);
                  })
                "
                :auto-upload="true"
                accept=".png, .jpg , .jpeg"
                :show-file-list="false"
              >
                <div
                  slot="tip"
                  v-if="uploadErr"
                  style="color: red; font-size: 10px"
                  class="el-upload__tip"
                >
                  The uploaded file should not exceed 5MB
                </div>
                <div class="input-group img-group">
                  <div class="text-center dropzone logo">
                    <div
                      class="addImage"
                      v-if="!category.showFileThumbnailUrl"
                      style="width: 100%; padding-top: 25px; color: #fff"
                    >
                      <a class="addImageIcon btn btn-primary btn-circle">
                        <i class="el-icon-upload2"></i>
                      </a>
                      <p class="text-primary m-t-sm font14 suggestFont">
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                    <div class="editImage" v-if="category.showFileThumbnailUrl">
                      <div class="mask-bg"></div>
                      <img :src="category.showFileThumbnailUrl" />
                      <div class="icon-center">
                        <span class="edit-icon">
                          <i class="el-icon-edit"></i>
                        </span>
                        <p class="font14 font-white editFont">Modify</p>
                        <p
                          class="
                            text-primary
                            font-white
                            m-t-sm
                            font14
                            suggestFont
                          "
                        >
                          <slot name="sizeHint"></slot>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-upload>
              <el-form-item
                v-if="category.fileType == 1"
                prop="fileThumbnailUrl"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }"
              >
                <el-input
                  style="display: none"
                  v-model="category.fileThumbnailUrl"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Simplified Chinese">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              File Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="fileNameSc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="category.fileNameSc" :name="'fileNameSc'"  maxlength="60" show-word-limit/>
              </el-form-item>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Description
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="descriptionSc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  maxlength="200"
                  show-word-limit
                  v-model="category.descriptionSc"
                  :name="'descriptionSc'"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-group" v-if="category.fileType == 1">
            <label class="col-sm-2 control-label">
              Document <span style="color: red">*</span></label
            >
            <div class="col-sm-10">
              <el-upload
                class="upload-demo upload-image"
                action="#"
                multiple
                :http-request="
                  (function (param) {
                    uploadDocument(param, 'Sc');
                  })
                "
                :auto-upload="true"
                accept=".doc, .DOC, .DOCX, .pdf, .PDF, .xls, XLS, xlsx, XLSX, .ppt, .PPT, .pptx, .PPTX, .ZIP"
                :limit="1"
                :file-list="documentFileListSc"
              >
                <div
                  slot="tip"
                  v-if="uploadErr"
                  style="color: red; font-size: 10px"
                  class="el-upload__tip"
                >
                  The uploaded file should not exceed 5MB
                </div>
                <el-button size="small" type="primary">Upload</el-button>
              </el-upload>
              <el-form-item
                :prop="'fileUrlSc'"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }"
              >
                <el-input
                  style="display: none"
                  v-model="category.fileUrlSc"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group" v-if="category.fileType == 1">
            <label class="col-sm-2 control-label"> Thumbnail Image </label>
            <div class="col-sm-10">
              <el-upload
                class="upload-demo upload-image"
                action="#"
                multiple
                :http-request="
                  (function (param) {
                    uploadImage(param, 'Sc');
                  })
                "
                :auto-upload="true"
                accept=".png, .jpg , .jpeg"
                :show-file-list="false"
              >
                <div
                  slot="tip"
                  v-if="uploadErr"
                  style="color: red; font-size: 10px"
                  class="el-upload__tip"
                >
                  The uploaded file should not exceed 5MB
                </div>
                <div class="input-group img-group">
                  <div class="text-center dropzone logo">
                    <div
                      class="addImage"
                      v-if="!category.showFileThumbnailUrlSc"
                      style="width: 100%; padding-top: 25px; color: #fff"
                    >
                      <a class="addImageIcon btn btn-primary btn-circle">
                        <i class="el-icon-upload2"></i>
                      </a>
                      <p class="text-primary m-t-sm font14 suggestFont">
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                    <div
                      class="editImage"
                      v-if="category.showFileThumbnailUrlSc"
                    >
                      <div class="mask-bg"></div>
                      <img :src="category.showFileThumbnailUrlSc" />
                      <div class="icon-center">
                        <span class="edit-icon">
                          <i class="el-icon-edit"></i>
                        </span>
                        <p class="font14 font-white editFont">Modify</p>
                        <p
                          class="
                            text-primary
                            font-white
                            m-t-sm
                            font14
                            suggestFont
                          "
                        >
                          <slot name="sizeHint"></slot>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-upload>
              <el-form-item
                v-if="category.fileType == 1"
                prop="fileThumbnailUrlSc"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }"
              >
                <el-input
                  style="display: none"
                  v-model="category.fileThumbnailUrlSc"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Traditional Chinese">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              File Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="fileNameTc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="category.fileNameTc" :name="'fileNameTc'"  maxlength="60" show-word-limit />
              </el-form-item>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Description
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="descriptionTc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  maxlength="200"
                  show-word-limit
                  v-model="category.descriptionTc"
                  :name="'descriptionTc'"
                  type="textarea"
                  :rows="4"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-group" v-if="category.fileType == 1">
            <label class="col-sm-2 control-label">
              Document <span style="color: red">*</span></label
            >
            <div class="col-sm-10">
              <el-upload
                class="upload-demo upload-image"
                action="#"
                multiple
                :http-request="
                  (function (param) {
                    uploadDocument(param, 'Tc');
                  })
                "
                :auto-upload="true"
                accept=".doc, .DOC, .DOCX, .pdf, .PDF, .xls, XLS, xlsx, XLSX, .ppt, .PPT, .pptx, .PPTX, .ZIP"
                :limit="1"
                :file-list="documentFileListTc"
              >
                <div
                  slot="tip"
                  v-if="uploadErr"
                  style="color: red; font-size: 10px"
                  class="el-upload__tip"
                >
                  The uploaded file should not exceed 5MB
                </div>
                <el-button size="small" type="primary">Upload</el-button>
              </el-upload>
              <el-form-item
                :prop="'fileUrlTc'"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }"
              >
                <el-input
                  style="display: none"
                  v-model="category.fileUrlTc"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group" v-if="category.fileType == 1">
            <label class="col-sm-2 control-label"> Thumbnail Image </label>
            <div class="col-sm-10">
              <el-upload
                class="upload-demo upload-image"
                action="#"
                multiple
                :http-request="
                  (function (param) {
                    uploadImage(param, 'Tc');
                  })
                "
                :auto-upload="true"
                accept=".png, .jpg , .jpeg"
                :show-file-list="false"
              >
                <div
                  slot="tip"
                  v-if="uploadErr"
                  style="color: red; font-size: 10px"
                  class="el-upload__tip"
                >
                  The uploaded file should not exceed 5MB
                </div>
                <div class="input-group img-group">
                  <div class="text-center dropzone logo">
                    <div
                      class="addImage"
                      v-if="!category.showFileThumbnailUrlTc"
                      style="width: 100%; padding-top: 25px; color: #fff"
                    >
                      <a class="addImageIcon btn btn-primary btn-circle">
                        <i class="el-icon-upload2"></i>
                      </a>
                      <p class="text-primary m-t-sm font14 suggestFont">
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                    <div
                      class="editImage"
                      v-if="category.showFileThumbnailUrlTc"
                    >
                      <div class="mask-bg"></div>
                      <img :src="category.showFileThumbnailUrlTc" />
                      <div class="icon-center">
                        <span class="edit-icon">
                          <i class="el-icon-edit"></i>
                        </span>
                        <p class="font14 font-white editFont">Modify</p>
                        <p
                          class="
                            text-primary
                            font-white
                            m-t-sm
                            font14
                            suggestFont
                          "
                        >
                          <slot name="sizeHint"></slot>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-upload>
              <el-form-item
                v-if="category.fileType == 1"
                prop="fileThumbnailUrlTc"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }"
              >
                <el-input
                  style="display: none"
                  v-model="category.fileThumbnailUrlTc"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <div class="form-group">
          <label class="col-sm-2 control-label">
            Category Type <span style="color: red">*</span></label
          >
          <div class="col-sm-10">
            <el-form-item
              prop="fileType"
              :rules="{
                required: true,
                message: $t('message.required'),
                trigger: 'blur',
              }"
            >
              <el-select
                v-model="category.fileType"
                @change="handleChangeFileTyle()"
              >
                <el-option
                  v-for="item in [
                    { val: 1, text: 'Document' },
                    { val: 2, text: 'Video' },
                  ]"
                  :key="item.val"
                  :label="item.text"
                  :value="item.val"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">
            Category Ids <span style="color: red">*</span></label
          >
          <div class="col-sm-10">
            <el-form-item
              prop="categoryIds"
              :rules="{
                required: true,
                message: $t('message.required'),
                trigger: 'blur',
              }"
            >
              <el-select v-model="category.categoryIds" multiple>
                <el-option
                  v-for="item in schoolResourcesCategory"
                  :key="item.id"
                  :label="item.categoryNameEn"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">
            Enable Date<span style="color: red">*</span></label
          >
          <div class="col-sm-10">
            <el-form-item prop="enableDate">
              <el-date-picker
                v-model="selectEnableDate"
                @change="handleSelectDate"
                :picker-options="pickerOptions"
                type="date"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <!--TODO-->
        <template v-if="category.fileType == 2">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Video <span style="color: red">*</span></label
            >
            <div class="col-sm-10">
              <el-form-item
                :prop="'fileUrl'"
                :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'blur',
                }"
              >
                <el-input
                  style="margin-bottom: 22px"
                  v-model="category.fileUrl"
                  show-word-limit
                ></el-input>
                <video
                  :src="category.fileUrl"
                  style="width: 100%"
                  controls="controls"
                ></video>
              </el-form-item>
            </div>
          </div>
        </template>
        <div class="form-group" v-if="category.fileType == 2">
          <label class="col-sm-2 control-label"> Thumbnail Image </label>
          <div class="col-sm-10">
            <el-upload
              class="upload-demo upload-image"
              action="#"
              multiple
              :http-request="uploadImage"
              :auto-upload="true"
              accept=".png, .jpg , .jpeg"
              :show-file-list="false"
            >
              <div
                slot="tip"
                v-if="uploadErr"
                style="color: red; font-size: 10px"
                class="el-upload__tip"
              >
                The uploaded file should not exceed 5MB
              </div>
              <div class="input-group img-group">
                <div class="text-center dropzone logo">
                  <div
                    class="addImage"
                    v-if="!category.showFileThumbnailUrl"
                    style="width: 100%; padding-top: 25px; color: #fff"
                  >
                    <a class="addImageIcon btn btn-primary btn-circle">
                      <i class="el-icon-upload2"></i>
                    </a>
                    <p class="text-primary m-t-sm font14 suggestFont">
                      <slot name="sizeHint"></slot>
                    </p>
                  </div>
                  <div class="editImage" v-if="category.showFileThumbnailUrl">
                    <div class="mask-bg"></div>
                    <img :src="category.showFileThumbnailUrl" />
                    <div class="icon-center">
                      <span class="edit-icon">
                        <i class="el-icon-edit"></i>
                      </span>
                      <p class="font14 font-white editFont">Modify</p>
                      <p
                        class="
                          text-primary
                          font-white
                          m-t-sm
                          font14
                          suggestFont
                        "
                      >
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <el-button
                type="primary"
                v-if="
                  (checkPermission('SchoolResources_LIST_EDIT') &&
                    $route.query.id) ||
                  (checkPermission('SchoolResources_LIST_ADD') &&
                    !$route.query.id)
                "
                @click="checkEvent()"
              >
                {{ $t("message.Save") }}
              </el-button>
              <el-button @click="$router.go(-1)">{{
                $t("message.Cancel")
              }}</el-button>
            </div>
          </div>
        </div>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import sha256 from "sha256";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      category: {
        fileNameEn: "",
        fileNameTc: "",
        fileNameSc: "",
        descriptionEn: "",
        descriptionTc: "",
        descriptionSc: "",
        fileUrl: "",
        fileUrlTc: "",
        fileUrlSc: "",
        showFileUrl: "",
        showFileUrlTc: "",
        showFileUrlSc: "",
        fileType: "",
        categoryIds: "",
        description: "",
        fileThumbnailUrl: "",
        showFileThumbnailUrl: "",
        fileThumbnailUrlTc: "",
        showFileThumbnailUrlTc: "",
        fileThumbnailUrlSc: "",
        showFileThumbnailUrlSc: "",
        enableDate: "",
      },
      selectEnableDate: "",
      documentFileList: [],
      documentFileListSC: [],
      documentFileListTC: [],
      schoolResourcesCategory: [],
      uploadErr: false,
    };
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: (date) => {
          const today = this.$dayjs().subtract(1, "day");
          return date < today.toDate();
        },
      };
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async handleChangeFileTyle() {
      this.category.categoryIds = [];
      this.schoolResourcesCategoryList(this.category.fileType);
    },
    checkEvent() {
      this.$refs["category"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async schoolResourcesCategoryList(fileType) {
      var objdata = this.getAuthObj();
      objdata.pageIndex = 1;
      objdata.pageSize = 100;
      objdata.categoryName = "";
      objdata.categoryType = fileType;
      objdata.apiUrl = this.apiConfig.schoolResourcesCategoryList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(
        this,
        "schoolResourcesCategory",
        data.data.result.schoolResourcesCategory
      );
    },
    uploadDocument(params, lang) {
      this.uploadFile(params, "document", lang);
    },
    uploadImage(params,lang) {
      if (!this.handleCheckUploadFileSize(params.file)) return false;
      this.uploadFile(params, "image",lang);
    },
    async uploadFile(params, uoloadType, lang) {
      const langKey = lang ? lang : "";
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (uoloadType == "document") {
        this.category[`fileUrl${langKey}`] = data.data.result.url;
        this.category[`showFileUrl${langKey}`] = data.data.result.showUrl;
        console.log(`11111 fileUrl${langKey}`,this.category[`fileUrl${langKey}`])
        console.log(`22222 showFileUrl${langKey}`,this.category[`showFileUrl${langKey}`])
      } else {
        this.category[`fileThumbnailUrl${langKey}`] = data.data.result.url;
        this.category[`showFileThumbnailUrl${langKey}`] = data.data.result.showUrl;
        console.log(`11111 fileUrl${langKey}`,this.category[`fileThumbnailUrl${langKey}`])
        console.log(`22222 showFileUrl${langKey}`,this.category[`showFileThumbnailUrl${langKey}`])
      }
      console.log("33333",this.category)
      
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.schoolResourcesDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (data.data.result.startTime) {
          this.period = [data.data.result.startTime, data.data.result.endTime];
        }
        if (!data) return;
        if (data.data.result.categoryIds) {
          data.data.result.categoryIds = data.data.result.categoryIds
            .split(",")
            .map(Number);
        }
        this.schoolResourcesCategoryList(data.data.result.fileType);
        this.$set(this, "category", data.data.result);
         const keysList = [
          "fileUrl",
          "showFileUrl",
          "fileUrlSc",
          "showFileUrlSc",
          "fileUrlTc",
          "showFileUrlTc",
          "fileThumbnailUrl",
          "showFileThumbnailUrl",
          "fileThumbnailUrlSc",
          "showFileThumbnailUrlSc",
          "fileThumbnailUrlTc",
          "showFileThumbnailUrlTc",
        ];
        keysList.forEach(i=>{
          if(!this.category[i]){
            this.category[i] = ''
          }
        })
        this.documentFileList = [
          {
            name: `${this.category.fileNameEn}.${
              this.category.fileUrl.split(".")[
                this.category.fileUrl.split(".").length - 1
              ]
            }`,
            url: this.category.showFileUrl,
          },
        ];
        this.documentFileListSc = [
          {
            name: `${this.category.fileNameSc}.${
              this.category.fileUrlSc.split(".")[
                this.category.fileUrlSc.split(".").length - 1
              ]
            }`,
            url: this.category.showFileUrlSc,
          },
        ];
        this.documentFileListTc = [
          {
            name: `${this.category.fileNameTc}.${
              this.category.fileUrlTc.split(".")[
                this.category.fileUrlTc.split(".").length - 1
              ]
            }`,
            url: this.category.showFileUrlTc,
          },
        ];
        this.selectEnableDate = data.data.result.enableDate
          ? this.$dayjs(data.data.result.enableDate).toDate()
          : "";
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
    },
    async submit() {
      let obj = this.getAuthObj();

      for (var key in this.category) {
        obj[key] = this.category[key];
      }
      var data;
      if (obj.categoryIds) {
        obj.categoryIds = obj.categoryIds.join(",");
      }
      if (this.$route.query.id) {
        obj.id = this.$route.query.id;
        obj.userId = this.$store.state.userInfo.userId;
        obj.apiUrl = this.apiConfig.schoolResourcesUpdate;
        data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = this.apiConfig.schoolResourcesCreate;
        data = await this.$store.dispatch("apiEvent", obj);
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$router.go(-1);
      }
    },
    handleSelectDate(e) {
      this.category.enableDate = this.$dayjs(e).format("YYYY-MM-DD");
    },
    handleCheckUploadFileSize(file) {
      const sizeKB = file.size / 1024;
      if (sizeKB > 5120) {
        this.uploadErr = true;
        return false;
      } else {
        this.uploadErr = false;
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-upload {
  text-align: start;
}
</style>